import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from '../../config/config';
import { map } from 'rxjs/operators';


@Injectable()
export class PitufoService {

    public myUrl=url+"pesosPitufo/";
    constructor(private http:HttpClient){

    }

    create(item){

        let headers=new HttpHeaders();
        let body=JSON.stringify(item);
        headers.append('Content-Type','application/json');
        return this.http.post(this.myUrl+"createPeso.php",body,{headers:headers}).pipe(map(resp=>{
            return resp;
        }));
    }
    listPesosPitufos(){
        let headers=new HttpHeaders();
        
       
        return this.http.get(this.myUrl+"LisPesosPitufo.php").pipe(map(resp=>{
            return resp;
        }));
    }

    getPesoPitufo(id){
        let headers=new HttpHeaders();
        let body=JSON.stringify(id);
        headers.append('Content-Type','application/json');
        return this.http.post(this.myUrl+"getIdPesoPitufo.php",body,{headers:headers}).pipe(map(resp=>{
            return resp;
        }));

    }
    updatePitufo(peso){
        let headers=new HttpHeaders();
        let body=JSON.stringify(peso);
        headers.append('Content-Type','application/json');
        return this.http.put(this.myUrl+"updatePesoPitufo.php",body,{headers:headers}).pipe(map(resp=>{
            return resp;
        }));
    }
    deletePitufo(id){
      
        const params = new HttpParams()
        .set('id',id.toString());
       
        return this.http.delete(this.myUrl+"deletePeso.php",{params}).pipe(map(resp=>{
            return resp;
        }));
    }
}